import { render } from "./ImagesTable.vue?vue&type=template&id=18ae2cda&scoped=true&ts=true"
import script from "./ImagesTable.vue?vue&type=script&lang=ts"
export * from "./ImagesTable.vue?vue&type=script&lang=ts"

import "./ImagesTable.vue?vue&type=style&index=0&id=18ae2cda&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ae2cda"]])

export default __exports__